// SAP's task `process` field is an open string domain; these are only the two codes EMMET
// acts on. Comparisons against it therefore widen the member to string rather than narrowing
// `process` to this enum, which would claim SAP returns nothing else.
export enum TaskCode {
  C45 = 'Z00000000000018',
  C47 = 'Z00000000000020',
}
